/**
 * Culture clips already play from the HTML iframe/video.
 * Hover/click sound + loop start/end.
 *
 * Hover is bound to the card (not the iframe) so the stretched
 * article link and the YouTube frame cannot steal the cursor.
 */
(function () {
  if (window.__mwCultureFeed) return;
  window.__mwCultureFeed = true;

  var clips = [];
  var ytQueue = [];
  var ytLoading = false;
  var loud = null;
  var canHover = !window.matchMedia || window.matchMedia("(any-hover: hover)").matches;

  function loadYouTubeApi(cb) {
    if (window.YT && window.YT.Player) {
      cb();
      return;
    }
    ytQueue.push(cb);
    if (ytLoading) return;
    ytLoading = true;
    var prev = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = function () {
      if (typeof prev === "function") prev();
      ytQueue.splice(0).forEach(function (fn) { fn(); });
    };
    var s = document.createElement("script");
    s.src = "https://www.youtube.com/iframe_api";
    document.head.appendChild(s);
  }

  function iframeEl(clip) {
    if (clip.api && clip.api.getIframe) {
      try { return clip.api.getIframe() || clip.iframe; } catch (e) {}
    }
    return clip.iframe || (clip.root && clip.root.querySelector("iframe"));
  }

  function post(clip, func, args) {
    var iframe = iframeEl(clip);
    if (!iframe || !iframe.contentWindow) return;
    try {
      iframe.contentWindow.postMessage(JSON.stringify({
        event: "command",
        func: func,
        args: args || []
      }), "*");
    } catch (e) {}
  }

  function play(clip) {
    try {
      if (clip.api && clip.api.playVideo) clip.api.playVideo();
      else if (clip.api && clip.api.play) clip.api.play().catch(function () {});
    } catch (e) {}
    post(clip, "playVideo");
  }

  function applyMute(clip, mute) {
    try {
      if (clip.api) {
        if (mute) {
          if (clip.api.mute) clip.api.mute();
          if (clip.api.muted !== undefined) clip.api.muted = true;
        } else {
          if (clip.api.unMute) clip.api.unMute();
          if (clip.api.setVolume) clip.api.setVolume(100);
          if (clip.api.muted !== undefined) clip.api.muted = false;
        }
      }
    } catch (e) {}
    post(clip, mute ? "mute" : "unMute");
    if (!mute) post(clip, "setVolume", [100]);
  }

  function setLoud(clip, on) {
    if (!clip) return;
    clip.wantLoud = !!on;
    if (on) {
      if (loud && loud !== clip) setLoud(loud, false);
      play(clip);
      applyMute(clip, false);
      clip.root.classList.add("is-loud");
      loud = clip;
    } else {
      applyMute(clip, true);
      clip.root.classList.remove("is-loud");
      if (loud === clip) loud = null;
    }
  }

  function unlockPlayer(clip) {
    if (!clip) return;
    try {
      if (clip.api && clip.api.unMute) {
        clip.api.unMute();
        if (clip.api.setVolume) clip.api.setVolume(0);
        clip.api.mute();
        if (clip.api.setVolume) clip.api.setVolume(100);
      }
    } catch (e) {}
    post(clip, "unMute");
    post(clip, "setVolume", [0]);
    post(clip, "mute");
    post(clip, "setVolume", [100]);
    if (clip.wantLoud) setLoud(clip, true);
  }

  function watchLoop(clip) {
    if (clip.timer) clearInterval(clip.timer);
    if (!clip.end || clip.end <= clip.start) return;
    clip.timer = setInterval(function () {
      try {
        var t = clip.api && clip.api.getCurrentTime ? clip.api.getCurrentTime() : (clip.api && clip.api.currentTime);
        if (typeof t === "number" && t >= clip.end - 0.15) {
          if (clip.api && clip.api.seekTo) clip.api.seekTo(clip.start, true);
          else if (clip.api) clip.api.currentTime = clip.start;
          post(clip, "seekTo", [clip.start, true]);
          play(clip);
        }
      } catch (e) {}
    }, 200);
  }

  function bindHot(clip) {
    var hot = clip.root.closest("[data-mw-clip-hot]")
      || clip.root.closest(".article-card")
      || clip.root.closest(".article-card-wrapper")
      || clip.root;

    hot.addEventListener("pointerenter", function () {
      if (canHover) setLoud(clip, true);
    });
    hot.addEventListener("pointerleave", function () {
      if (canHover) setLoud(clip, false);
    });
    hot.addEventListener("pointerdown", function () {
      unlockPlayer(clip);
      setLoud(clip, true);
    });
    clip.root.addEventListener("click", function (e) {
      if (clip.root.classList.contains("mw-clip--hero") || !canHover) {
        e.preventDefault();
      }
      unlockPlayer(clip);
      setLoud(clip, true);
    });
  }

  function enhanceYouTube(clip, iframe) {
    clip.iframe = iframe;

    function start() {
      if (clip.playerStarted) return;
      clip.playerStarted = true;
      loadYouTubeApi(function () {
        var target = iframe.id || iframe;
        clip.api = new YT.Player(target, {
          events: {
            onReady: function (e) {
              clip.api = e.target;
              try { clip.iframe = e.target.getIframe() || iframe; } catch (err) {}
              clip.ready = true;
              try {
                e.target.mute();
                e.target.playVideo();
                if (clip.start) e.target.seekTo(clip.start, true);
              } catch (err) {}
              clip.root.classList.add("is-playing");
              watchLoop(clip);
              unlockPlayer(clip);
              if (clip.wantLoud) setLoud(clip, true);
            },
            onStateChange: function (e) {
              if (e.data === YT.PlayerState.PLAYING) clip.root.classList.add("is-playing");
              if (e.data === YT.PlayerState.ENDED && clip.start) {
                e.target.seekTo(clip.start, true);
                e.target.playVideo();
              }
              if (clip.wantLoud && e.data === YT.PlayerState.PLAYING) applyMute(clip, false);
            }
          }
        });
      });
    }

    iframe.addEventListener("load", start, { once: true });
    if (iframe.dataset && iframe.dataset.loaded === "1") start();
    try {
      if (iframe.contentWindow && iframe.getAttribute("loading") !== "lazy") start();
    } catch (e) {}
    start();

    if ("IntersectionObserver" in window && iframe.getAttribute("loading") === "lazy") {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            try { iframe.loading = "eager"; } catch (err) {}
            start();
            io.disconnect();
          }
        });
      }, { rootMargin: "200px" });
      io.observe(iframe);
    }
  }

  function enhanceHtml5(clip, video) {
    clip.api = video;
    clip.ready = true;
    video.muted = true;
    video.play().catch(function () {});
    video.addEventListener("playing", function () {
      clip.root.classList.add("is-playing");
    });
    watchLoop(clip);
    if (clip.wantLoud) setLoud(clip, true);
  }

  function boot() {
    document.querySelectorAll("[data-mw-clip][data-src]").forEach(function (root) {
      if (root.__mwClip) return;
      var iframe = root.querySelector("iframe.mw-clip__frame");
      var video = root.querySelector("video.mw-clip__frame");
      var clip = {
        root: root,
        api: null,
        iframe: iframe,
        start: parseFloat(root.getAttribute("data-start") || "0") || 0,
        end: parseFloat(root.getAttribute("data-end") || "0") || 0,
        timer: null,
        wantLoud: false,
        ready: false,
        playerStarted: false
      };
      root.__mwClip = clip;
      clips.push(clip);
      bindHot(clip);
      if (iframe) enhanceYouTube(clip, iframe);
      else if (video) enhanceHtml5(clip, video);
    });
  }

  document.addEventListener("pointerdown", function () {
    clips.forEach(unlockPlayer);
  }, true);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
